import { render, staticRenderFns } from "./ShowImg.vue?vue&type=template&id=1ee213a4&scoped=true&"
import script from "./ShowImg.vue?vue&type=script&lang=js&"
export * from "./ShowImg.vue?vue&type=script&lang=js&"
import style0 from "./ShowImg.vue?vue&type=style&index=0&id=1ee213a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee213a4",
  null
  
)

export default component.exports